// src/Dashboard/pages/admin/Attendance/components/AttendanceEmptyState.jsx
import React from "react";
import { FaClipboardList } from "react-icons/fa";

export default function AttendanceEmptyState() {
  return (
    <section className="rounded-3xl border border-dashed border-slate-300 bg-white p-10 text-center dark:border-slate-700 dark:bg-slate-900">
      <div className="mx-auto grid h-16 w-16 place-items-center rounded-3xl bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300">
        <FaClipboardList className="text-2xl" />
      </div>

      <h3 className="mt-4 text-lg font-bold text-slate-950 dark:text-white">
        Aucun adhérent trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun adhérent ne correspond au groupe ou aux filtres sélectionnés.
        Vérifiez la saison, le statut ou votre recherche.
      </p>
    </section>
  );
}